var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gz-breadcrumbs"},[_c('span',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("назад")]),_vm._v("\n     / \n    "),_c('span',[_vm._v(_vm._s(_vm.currentPageName))])])}
var staticRenderFns = []

export { render, staticRenderFns }